import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonCountDownDataAccessCountDownModule } from '@ecosure-suite/common/count-down/data-access-count-down';
import { CountDownComponent, CountDownTimerComponent } from './containers';
import {
  COUNTDOWN_CONFIGURATION_TOKEN,
  CountDownConfigurationToken
} from './tokens';
import { ToasterModule } from 'angular2-toaster';

@NgModule({
  imports: [
    CommonModule,
    CommonCountDownDataAccessCountDownModule,
    ToasterModule.forChild()
  ],
  declarations: [CountDownComponent, CountDownTimerComponent],
  exports: [CountDownComponent, CountDownTimerComponent],
  entryComponents: [CountDownComponent, CountDownTimerComponent]
})
export class CommonCountDownShellModule {
  static forRoot(config: CountDownConfigurationToken): ModuleWithProviders {
    return {
      ngModule: CommonCountDownShellModule,
      providers: [
        {
          provide: COUNTDOWN_CONFIGURATION_TOKEN,
          useValue: config
        }
      ]
    };
  }
}
